import {
	defineMessages,
	type MessageDescriptorV2 as MessageDescriptor,
} from '@atlassian/jira-intl';

const messages: {
	[key: string]: MessageDescriptor;
} = defineMessages({
	timeSpent: {
		id: 'issue-create-commons.log-work-field.time-spent',
		defaultMessage: 'Time Spent',
		description: 'Time Spent label',
	},
	timeRemaining: {
		id: 'issue-create-commons.log-work-field.time-remaining',
		defaultMessage: 'Time Remaining',
		description: 'Time Remaining label',
	},
	dateStarted: {
		id: 'issue-create-commons.log-work-field.date-started',
		defaultMessage: 'Date Started',
		description: 'Date started label',
	},
	description: {
		id: 'issue-create-commons.log-work-field.description',
		defaultMessage: 'Work Description',
		description: 'Work Description label',
	},
	originalEstimateExceededNonFinal: {
		id: 'issue-create-commons.log-work-field.original-estimate-exceeded-non-final',
		defaultMessage: 'Time logged has exceeded the original estimate',
		description: 'When time spent + remaining > time tracking value',
	},
	logWorkLabel: {
		id: 'issue-create-commons.log-work-field.log-work-label',
		defaultMessage: 'Log Work',
		description: 'log work field label',
	},
});

export default messages;
